/* nxg-v10-pages.js - Main Theme V10 (NOMAD phase 4). About, FAQ, contact, search.
   1. FAQ: filters the server-rendered <details> rows as the shopper types.
   2. Search: loads the theme's predictive search script on first focus of the
      page search field (same lazy pattern as the header in section-header.js)
      and closes the suggestion list on Escape or an outside click. */
(function () {
  'use strict';

  /* 1. FAQ search */
  document.querySelectorAll('[data-np-faq]').forEach(function (root) {
    var input = root.querySelector('[data-np-faq-input]');
    if (!input) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('.np-faq__item'));
    var count = root.querySelector('[data-np-faq-count]');
    var none = root.querySelector('[data-np-faq-none]');
    var run = function () {
      var words = input.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
      var visible = 0;
      items.forEach(function (item) {
        var hay = item.getAttribute('data-faq') || '';
        var match = words.every(function (w) { return hay.indexOf(w) !== -1; });
        item.hidden = !match;
        if (match) visible += 1;
      });
      if (count) count.textContent = visible + ' ' + (visible === 1 ? 'answer' : 'answers');
      if (none) none.hidden = visible !== 0;
    };
    input.addEventListener('input', run);
    input.addEventListener('search', run);
  });

  /* 2. Search page predictive suggestions */
  var field = document.querySelector('[data-np-search-input]');
  if (field) {
    var features = {};
    try { features = JSON.parse(document.getElementById('shopify-features').text); } catch (e) { features = {}; }
    var holder = field.closest('search-form');
    var list = holder ? holder.querySelector('[data-js-search-results]') : null;
    if (features.predictiveSearch && window.KROWN && KROWN.settings && KROWN.settings.predictive_search_script) {
      field.addEventListener('focus', function () {
        if (holder && field.value.trim() !== '') holder.classList.add('is-open');
        if (!document.body.classList.contains('predictive-script-loaded')) {
          document.body.classList.add('predictive-script-loaded');
          var s = document.createElement('script');
          s.src = KROWN.settings.predictive_search_script;
          document.head.appendChild(s);
        }
      });
    }
    var close = function () { if (holder) holder.classList.remove('is-open'); };
    field.addEventListener('input', function () {
      if (!holder) return;
      if (field.value.trim() === '') close(); else holder.classList.add('is-open');
    });
    field.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (holder && !holder.contains(e.target)) close(); });
    if (list) list.addEventListener('focusout', function (e) { if (holder && !holder.contains(e.relatedTarget)) close(); });
  }
})();
